import * as React from 'react';
import Skeleton from 'react-loading-skeleton';
import { classes } from '../../utils/Classes';

const searchSuggestionsSkeletonItemClassnames = classes('search-suggestions-skeleton-item');
const SearchSuggestionsSkeleton = () => (
    <>
        {Array(5).fill(
            <li className={searchSuggestionsSkeletonItemClassnames}>
                <Skeleton />
            </li>
        )}
    </>
);

export default SearchSuggestionsSkeleton;
